import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import img from '@/assets/not-found.png';
import Button from '@/modules/Button';
import * as urls from '@/api/urls';
import { AppContext } from '@/stateManager';

import SimplePage from '@/modules/simplePage';
import { deleteSessionStorage } from '@/utils/session';

const CeDenied = (props: any) => {
  const ceid = props.match.params.ceid;
  const context = useContext<any>(AppContext);
  deleteSessionStorage('_session');

  const ce_text = `Grundet vores interne kreditregler kan vi desværre ikke godkende dit køb. Derfor bliver din bestilling ikke gennemført.<br><br><h3>Har du spørgsmål?</h3> Du er velkommen til at ringe til os på <a className="simple-page__text__bold-link" href="tel:80800150">80 80 01 50</a>. Vi sidder klar ved telefonerne mandag-lørdag kl. 8-20. Husk at oplyse: <b data-hj-suppress>${ceid}</b>   , når du ringer. Så finder vi hurtigt de oplysninger, vi skal bruge for at hjælpe dig. <br><br>Venlig hilsen<br>YouSee
`;
  return (
    <div className="container">
      <SimplePage title={'Din bestilling bliver desværre ikke gennemført'}>
        <img loading="lazy" width="400px" height="400px" className="simple-page__image" src={img} />
        <p className="simple-page__text">
          <span dangerouslySetInnerHTML={{ __html: ce_text }}></span>
        </p>
        <Button
          display="block-centered"
          value="Gå til forsiden"
          onClick={() => {
            context.dispatch({ type: 'setFatalError', payload: { fatalError: true } });
            props.history.push(urls.simo.url());
          }}
        />
      </SimplePage>
    </div>
  );
};

CeDenied.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default CeDenied;
